// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3pyv2","gfeWrapper":"CalendarEvent_gfeWrapper__AOi5R"};